import React, { useState, useEffect } from "react"
import removeMd from "remove-markdown"

import styled from "styled-components"

import {
  InstantSearch,
  Hits,
  SearchBox,
  Pagination,
  Highlight,
  connectStateResults,
} from "react-instantsearch-dom"

import { instantMeiliSearch } from "@meilisearch/instant-meilisearch"
import useDebounce from "../../hooks/useDebounce"
import { StaticQuery, graphql } from "gatsby"

const searchClient = instantMeiliSearch(
  "https://blsearch.resistance.biz",
  "hyHl6tDBb91ebea123ddc4ea44c886f162949b4c2597292e9e3ae9897ffdcca2759becb4",
  {
    paginationTotalHits: 200,
    hitsPerPage: 2, // default: 200.
    placeholderSearch: true, // default: true.
    primaryKey: "id",
  }
)

function SearchComponent(props) {
  const { handleClose } = props

  const [query, setQuery] = useState(``)
  const [news, setNews] = useState([])
  const [domaine, setDomaine] = useState([])
  const debouncedQuery = useDebounce(query, 500)

  useEffect(() => {
    async function fetchMyAPI() {
      let response = await fetch(
        `https://lafon.coeur.pw/news-blogs?Title_contains=${query}`
      )
      response = await response.json()
      setNews(response)
    }
    async function fetchMydomaines() {
      let response = await fetch(
        `https://lafon.coeur.pw/domaines?Domaine_contains=${query}`
      )
      response = await response.json()
      setDomaine(response)
      //console.log("happening")
    }
    if (query !== "" && query.length > 3) {
      fetchMyAPI()
    }
  }, [debouncedQuery])

  return (
    <div
      id="extralarge-modal"
      tabIndex="-1"
      className={` 
         absolute -z-10 top-0 right-0 left-0 w-full md:inset-0`}
    >
      <InstantSearch
        indexName="wines"
        searchClient={searchClient}
        onSearchStateChange={({ query }) => setQuery(query)}
      >
        <div
          className={`mainContainer top-[100px]  z-[200] absolute inset-x-0 bg-white w-full m-auto shadow-lg`}
          style={{ minHeight: "850px" }}
        >
          <div className="flex justify-between items-center p-5 rounded-t border-b border-t relative">
            <SearchBox className="searchBox__modal" />
            <div className="yople hidden">
              <button
                type="button"
                className=" text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                onClick={() => handleClose()}
              >
                <svg
                  className="w-10 h-10"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>
          </div>
          <div className="p-8">
            <GridWrapp>
              <div className="gridRootSearch">
                <div className="mx-auto w-full p-4">
                  <Results>
                    <div
                      className="text-center mx-auto pb-8"
                      style={{ maxWidth: "1000px" }}
                    >
                      {query.length > 1 && <h2>Wines</h2>}
                    </div>
                    <Hits hitComponent={Hit} />
                  </Results>
                </div>
                {query.length > 1 && (
                  <Pagination className="paGination font-medium p-4 mx-auto max-w-lg -mt-[40px] " />
                )}

                {news.length > 0 && (
                  <div className="p-4 mx-auto">
                    <h2 className="pb-8 text-center">News</h2>{" "}
                    <SearchTemplate props={news} />
                  </div>
                )}

                {/* {domaine.length > 0 && (
                  <div className="p-4 mx-auto">
                    <h2 className="pb-8 text-center">Wineries</h2>{" "}
                    <SearchTemplate props={domaine} />
                  </div>
                )} */}

                {/* {query.length === 0 && (
                  <GatsbyImage
                    image={
                      data.backdrop.nodes[0].childImageSharp.gatsbyImageData
                    }
                    alt={`Search Page Placeholder`}
                  />
                )} */}
              </div>
            </GridWrapp>
          </div>
        </div>
      </InstantSearch>
    </div>
  )
}

const Results = connectStateResults(
  ({ searchState, searchResults, children }) =>
    searchResults && searchResults.nbHits !== 0 ? children : <p></p>
)

function Hit(props) {
  return (
    <div className=" bg-white shadow sm:rounded-lg h-full">
      <div className="border-t border-gray-200 py-2 sm:p-0 h-full">
        <dl className="sm:divide-y sm:divide-gray-200 h-full">
          <div className="mobileSearch flex items-center justify-between h-full overflow-hidden">
            <img
              src={`https://lafon.coeur.pw${props.hit.MainImage?.formats?.thumbnail?.url}`}
              className="h-[120px] w-[252px] object-contain"
            />

            <div className="max-w-[500px]">
              <h3 className="text-2xl important">
                <Highlight
                  attribute="title"
                  hit={props.hit}
                  className={"mr-4"}
                />
              </h3>
              <p className="text-left">
                {props.hit.Description.slice(0, 200)}
                {".."}
              </p>
            </div>
            {/* <button className="rounded bg-red-700 hover:bg-red-800 py-2 px-4 text-base font-bold text-white">
              <a
                target="_blank"
                href={`https://vincod.com/${props.hit.vincod}/get/print`}
                rel="noopener noreferrer"
              >
                Wine
              </a>
            </button>
            <button className="rounded bg-red-700 hover:bg-red-800 py-2 px-4 text-base font-bold text-white">
              <a
                target="_blank"
                href={`https://vincod.com/${props.hit.vincod}/get/print`}
                rel="noopener noreferrer"
              >
                Winery
              </a>
            </button> */}
            <button className="w-[105px] shadow rounded bg-red-700 hover:bg-red-800  mr-8 text-base font-bold text-white">
              <a
                target="_blank"
                href={`https://vincod.com/${props.hit.vincod}/get/print`}
                rel="noopener noreferrer"
                className="w-full h-full block py-2 px-4"
              >
                PDF
              </a>
            </button>
          </div>
        </dl>
      </div>
    </div>
  )
}

function SearchTemplate({ props }) {
  return (
    <>
      {props.map(e => (
        <div
          className=" bg-white shadow sm:rounded-lg h-full mx-auto"
          style={{ maxWidth: "1000px" }}
          key={e.id}
        >
          <div className="border-t border-gray-200 py-2 sm:p-0 h-full">
            <dl className="sm:divide-y sm:divide-gray-200 h-full">
              <div className=" mobileSearch flex items-center justify-between h-full">
                <img
                  src={`https://lafon.coeur.pw${
                    e.Domaine
                      ? e.MainImage?.formats?.small?.url
                      : e.MainMedia?.formats?.small?.url
                  }`}
                  className="overflow-hidden shadow object-cover h-[140px] w-[252px]"
                />

                <div className="max-w-[500px]">
                  <h3 className="mr-4">{e.Domaine ? e.Domaine : e.Title}</h3>
                  <p>
                    {e.Domaine
                      ? e.Description.slice(0, 200)
                      : removeMd(e.Content.slice(0, 200))}
                    {".."}
                  </p>
                </div>
                <button className="rounded w-[105px] shadow bg-red-700 hover:bg-red-800 text-base font-bold text-white mr-8">
                  <a
                    target="_blank"
                    href={`https://brunolafonselection.com/news/${
                      e.Domaine ? e.Slug : e.slug
                    }/`}
                    rel="noopener noreferrer"
                    className="w-full h-full block py-2 px-4 "
                  >
                    More info
                  </a>
                </button>
              </div>
            </dl>
          </div>
        </div>
      ))}
    </>
  )
}

export const GridWrapp = styled.div`
  /* .gridRootSearch {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  } */

  .ais-Hits-list {
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
    max-width: 1000px;
  }

  .ais-Pagination-list {
    justify-content: center;
  }

  .ais-Hits-item {
    height: 160px;
    margin-bottom: 2rem !important;
  }

  .ais-Highlight {
    font-size: 1.2rem !important;
  }

  h3 {
    color: var(--headblack);
    font-size: 1.2rem;
    font-weight: 700 !important;
  }
  h2 {
    font-weight: 700 !important;
    font-size: 1.7rem;
  }
`

export default function SearchModal(props) {
  const { handleClose } = props
  return (
    <StaticQuery
      query={graphql`
        query {
          backdrop: allFile(filter: { relativePath: { regex: "/wine404/" } }) {
            nodes {
              childImageSharp {
                gatsbyImageData(width: 1800, quality: 60)
              }
            }
          }
        }
      `}
      render={data => <SearchComponent data={data} handleClose={handleClose} />}
    />
  )
}
